// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"12":"10cfefa0","41":"dd4403d6","301":"69b4b715","315":"b6b91c2e","374":"7e07bd3a","400":"dc83c9fe","466":"ee5638b1","524":"a5e90dc3","568":"406e8017","678":"4e2b84df","688":"5f630526","818":"b03ebf06","828":"538ed358","851":"45be80f3","892":"75ad35c5"}[chunkId] + ".js";
};